// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../widget-membership-application-app/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../widget-membership-application-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sgf-ace.sgf-app-shell-atom[data-v-59aea3e2]{background:var(--sgf-c-background)}.sgf-ace .sgf-app-shell-atom__layout[data-v-59aea3e2]{display:grid;grid-template-columns:minmax(0,1fr);gap:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
